import IdeateLiveLogoBlack from '@proj-client/assets/imgs/nav/ideatelive_logo_black.svg'

export const FooterGeneric = (props) => {

    return (
        <div className="px-2 border-t border-slate-200 bg-white">
            <div className="container mx-auto ">
                <footer className="flex flex-col p-8 space-y-4 text-slate-700">

                    <div><a href="./"><IdeateLiveLogoBlack className="w-auto h-5 sm:h-5" /></a></div>

                    <div className='h-5 md:h-10'></div>
                    {//TODO:
                        //<div>fotter block grid</div>
                        //<div>social links</div>
                        //<div>content highlights</div>
                    }
                    <div className="flex flex-col space-y-4 md:flex-row-reverse md:justify-between">
                        <div className="flex flex-row items-center space-x-4">
                            <a href="/terms-and-conditions" className='hover:underline'>Terms</a>
                            <a href="/privacy-policy" className='hover:underline'>Privacy </a>
                            <a href="/cookie-policy" className='hover:underline'>Cookies</a>
                        </div>
                        <div className="">© 2022 IdeateLive. All Rights Reserved.</div>
                    </div>
                </footer>
            </div>
        </div> 
    )
}
